import { getFillByLot } from "../manzanas/Manzana2Div1";

export const Manzana61Div1M2 = ({
  lands,
  landSelector = (_e, _id) => {},
  selected,
  style,
}) => {
  const findLandByLot = (lot) => {
    return lands.filter((l) => l.lote === lot)[0];
  };

  if (!lands) {
    return <></>;
  }

  return (
    <svg
      width={style?.width || "1219"}
      height={style?.height || "941"}
      viewBox="0 0 1221 921"
      fill="none"
    >
      <rect width="1221" height="921" fill="url(#pattern0_1466_23554)" />
      <path
        className="cursor-pointer"
        onClick={(e) => landSelector(e, findLandByLot("6"))}
        d="M330.289 566.649L363.026 545.816L392.786 591.946L351.121 618.731C345.665 610.299 333.563 591.351 328.801 583.018C324.039 574.685 327.809 568.633 330.289 566.649Z"
        fill={getFillByLot(6, selected, lands)}
        fill-opacity="0.64"
        stroke="#6D6859"
        stroke-opacity="0.6"
      />
      <path
        className="cursor-pointer"
        onClick={(e) => landSelector(e, findLandByLot("7"))}
        d="M374.934 657.424L351.125 618.734L391.302 593.438L422.551 642.543L392.79 661.888C383.267 664.269 376.918 659.904 374.934 657.424Z"
        fill={getFillByLot(7, selected, lands)}
        fill-opacity="0.64"
        stroke="#6D6859"
        stroke-opacity="0.6"
      />
      <path
        className="cursor-pointer"
        onClick={(e) => landSelector(e, findLandByLot("8"))}
        d="M462.719 617.246L422.542 642.543L391.293 593.437L432.958 566.652L462.719 617.246Z"
        fill={getFillByLot(8, selected, lands)}
        fill-opacity="0.64"
        stroke="#6D6859"
        stroke-opacity="0.6"
      />
      <path
        className="cursor-pointer"
        onClick={(e) => landSelector(e, findLandByLot("9"))}
        d="M504.385 590.463L462.72 617.248L432.959 566.654L474.624 541.357L504.385 590.463Z"
        fill={getFillByLot(9, selected, lands)}
        fill-opacity="0.64"
        stroke="#6D6859"
        stroke-opacity="0.6"
      />
      <path
        className="cursor-pointer"
        onClick={(e) => landSelector(e, findLandByLot("5"))}
        d="M406.181 519.035L363.027 545.82L392.788 591.95L434.454 565.165L406.181 519.035Z"
        fill={getFillByLot(5, selected, lands)}
        fill-opacity="0.64"
        stroke="#6D6859"
        stroke-opacity="0.6"
      />
      <path
        className="cursor-pointer"
        onClick={(e) => landSelector(e, findLandByLot("5"))}
        d="M447.837 492.246L406.172 519.031L434.445 565.16L476.11 539.864L447.837 492.246Z"
        fill={getFillByLot(5, selected, lands)}
        fill-opacity="0.64"
        stroke="#6D6859"
        stroke-opacity="0.6"
      />
      <path
        className="cursor-pointer"
        onClick={(e) => landSelector(e, findLandByLot("10"))}
        d="M544.563 565.168L504.386 590.465L474.625 541.359L514.802 516.062L544.563 565.168Z"
        fill={getFillByLot(10, selected, lands)}
        fill-opacity="0.64"
        stroke="#6D6859"
        stroke-opacity="0.6"
      />
      <path
        className="cursor-pointer"
        onClick={(e) => landSelector(e, findLandByLot("3"))}
        d="M490.989 465.463L447.836 492.248L476.109 539.865L519.262 513.08L490.989 465.463Z"
        fill={getFillByLot(3, selected, lands)}
        fill-opacity="0.64"
        stroke="#6D6859"
        stroke-opacity="0.6"
      />
      <path
        className="cursor-pointer"
        onClick={(e) => landSelector(e, findLandByLot("2"))}
        d="M532.665 440.166L491 465.463L519.273 513.08L560.938 486.296L532.665 440.166Z"
        fill={getFillByLot(2, selected, lands)}
        fill-opacity="0.64"
        stroke="#6D6859"
        stroke-opacity="0.6"
      />
      <path
        className="cursor-pointer"
        onClick={(e) => landSelector(e, findLandByLot("11"))}
        d="M586.227 538.379L544.562 565.164L514.801 516.058L556.466 489.273L586.227 538.379Z"
        fill={getFillByLot(11, selected, lands)}
        fill-opacity="0.64"
        stroke="#6D6859"
        stroke-opacity="0.6"
      />
      <path
        className="cursor-pointer"
        onClick={(e) => landSelector(e, findLandByLot("12"))}
        d="M627.891 511.596L586.226 538.381L556.465 489.275L596.642 463.979L627.891 511.596Z"
        fill={getFillByLot(12, selected, lands)}
        fill-opacity="0.64"
        stroke="#6D6859"
        stroke-opacity="0.6"
      />
      <path
        className="cursor-pointer"
        onClick={(e) => landSelector(e, findLandByLot("13"))}
        d="M671.043 484.809L627.89 511.594L596.641 463.976L618.961 449.096L671.043 468.44C674.614 475.583 672.531 482.329 671.043 484.809Z"
        fill={getFillByLot(13, selected, lands)}
        fill-opacity="0.64"
        stroke="#6D6859"
        stroke-opacity="0.6"
      />
      <path
        className="cursor-pointer"
        onClick={(e) => landSelector(e, findLandByLot("1"))}
        d="M553.493 426.776L532.66 440.169L560.933 486.299L618.967 449.097C603.094 441.657 568.969 426.479 565.397 425.288C561.826 424.098 555.973 425.784 553.493 426.776Z"
        fill={getFillByLot(1, selected, lands)}
        fill-opacity="0.64"
        stroke="#6D6859"
        stroke-opacity="0.6"
      />
      <defs>
        <pattern
          id="pattern0_1466_23554"
          patternContentUnits="objectBoundingBox"
          width="1"
          height="1"
        >
          <use
            href="#image0_1466_23554"
            transform="matrix(0.00204111 0 0 0.00270596 -2.47891 -2.07063)"
          />
        </pattern>
        <image
          id="image0_1466_23554"
          width="4096"
          height="2304"
          href="/mz2.png"
        />
      </defs>
    </svg>
  );
};
